import React, { useEffect } from 'react';
import CONSTS from './../config/constants';

const Hotjar = () => {
  //Hotjar Tracking Code for https://tramitta.cl/
  const sendReport = () => {
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
      h._hjSettings = { hjid: 2300487, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script'); r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENV === CONSTS.ENV.PROD) {
      sendReport();
    }
  }, []);

  return (<></>);
};

export default Hotjar;